<template>
	<div>
		<p>На этой странице выводится Ваша история редактирования.</p>
		<el-row :gutter="40">
			<el-col :span="14">
				<el-table :data="recipes.filter(data => !search || data.displayName.toLowerCase().includes(search.toLowerCase()))" style="width: 100%">
				    <el-table-column label="Предмет" prop="name">
				      <template slot-scope="scope">
				      	<el-image style="width: 32px; height: 32px; display: inline-block; vertical-align: middle; margin-right: 5px;" :src="scope.row.image"></el-image>
			        	<span>{{scope.row.displayName}}</span>
			        	<p>&nbsp;</p>
				      	<el-row type="flex" justify="left" :gutter="40">
						  	<el-col :span="7">
					        	<el-row style="margin-bottom: 16px;">
						  			<el-col :span="24"><h2><nobr>Рецепт в БД</nobr></h2></el-col>
						  		</el-row> 
						  		<el-row v-for="i in 3" style="margin-bottom: 16px;">
						  			<el-col :span="8" v-for="j in 3">
										<img :src="scope.row.iconsOld[(i-1)*3+(j-1)]" alt="" :title="scope.row.titlesOld[(i-1)*3+(j-1)]" style="width: 32px; height: 32px; display: inline-block; vertical-align: middle; border: 1px solid; background-color: rgba(0,0,0,.1);">
						  			</el-col>
						  		</el-row>
						  		<p>Количество: {{scope.row.meta.recipe.count}}</p>
						  	</el-col>
						  	<el-col :span="7">
					        	<el-row style="margin-bottom: 16px;">
						  			<el-col :span="24"><h2><nobr>Новый рецепт</nobr></h2></el-col>
						  		</el-row> 
						  		<el-row v-for="i in 3" style="margin-bottom: 16px;">
						  			<el-col :span="8" v-for="j in 3">
										<img :src="scope.row.icons[(i-1)*3+(j-1)]" alt="" :title="scope.row.titles[(i-1)*3+(j-1)]" style="width: 32px; height: 32px; display: inline-block; vertical-align: middle; border: 1px solid; background-color: rgba(0,0,0,.1);">
						  			</el-col>
						  		</el-row>
						  		<p>Количество: {{scope.row.data.count}}</p>
						  	</el-col>
						</el-row>
				      </template>
				    </el-table-column>
				    <el-table-column label="Опции" width="160" prop="options">
				    	<template slot="header" slot-scope="scope">
					        <el-input style="width: 100%; padding: 0;" v-model="search" size="mini" placeholder="Предмет"/>
					    </template>
				      	<template slot-scope="scope">
							<div style="text-align: right;">
								<el-button size="mini" @click="updateRecipe(scope.row)">Обновить рецепт</el-button><br><br>
								<el-button size="mini" @click="removeRecipe(scope.row)">Отклонить рецепт</el-button>
							</div>
				      	</template>
				    </el-table-column>
				</el-table>
			</el-col>
		</el-row>	
	</div>
</template>

<script>
import {db} from '../firebase.js';
export default {
  	data() {
	    return {
	    	search: '',
	    	recipes: [],
	    	recipesDB: [],
	    };
  	},
  	computed: {
  	},
  	mounted() {
  		var self = this;
  		self.setRecipes();
  		self.$store.subscribe((mutation, state) => {
	      switch(mutation.type) {
	        case 'updateItemCollection':
	          	self.setRecipes();
	        break; 
	      };       
	    });
  	},	
  	methods: {
  		removeRecipe(row){
  			var self = this;
			self.recipes.forEach((el, i)=>{
  				// console.log(el);				
				if (el.data.item == row.meta.name && el.data.author == row.data.author) {
					self.recipes.splice(i, 1);
				};
			});
			self.recipesDB.forEach((el, i)=>{
				if (el.item == row.meta.name && el.author == row.data.author) {
					self.recipesDB.splice(i, 1);
				};
			});
			db.collection("logs").doc("suggest-recipes").update({
			    recipes: self.recipesDB,
			});
  		},
  		updateRecipe(row){
  			var self = this;
  			var item = {};
  			item[row.data.item] = row.meta;
  			item[row.data.item].recipe = {
  				pattern: row.data.pattern,
			    key: row.data.key,
			    count: row.data.count,
			};
  			db.collection('mods').doc(row.meta.mod).update(item).then(function() {
			  	self.$notify({title: 'Успех', message: 'Рецепт успешно обновлён', type: 'success'});
				self.recipes.forEach((el, i)=>{
					if (el.data.item == row.meta.name) {
						self.recipes.splice(i, 1);
					};
				});
				self.recipesDB.forEach((el, i)=>{
					if (el.item == row.meta.name) {
						self.recipesDB.splice(i, 1);
					};
				});
				db.collection("logs").doc("suggest-recipes").update({
				    recipes: self.recipesDB,
				});
			});
  		},
  		setRecipes(){
  			var self = this;
  			// var recipes = [];
  			db.collection('logs').doc('suggest-recipes').get().then(function(doc){
	  			var recipes = doc.data().recipes;
	  			self.recipesDB = recipes;
				// console.log(self.recipesDB);
	  			recipes.forEach(el=>{
	  				if (el.mod && el.item) {
		  				var meta = self.$store.state.itemCollection[el.mod].find(subEl=>{return subEl.name == el.item});
		  				// console.log(el);
		  				var icons = ['','','','','','','','',''];
						var titles = ['','','','','','','','',''];
		  				var iconsOld = ['','','','','','','','',''];
						var titlesOld = ['','','','','','','','',''];
						el.pattern.forEach(function(subEl, i){
			        		subEl.split('').forEach(function(subSubEl, j){
			        			// console.log();
			        			if (subSubEl != ' ' && el.key[subSubEl].mod) {
			        				// console.log(el.key[subSubEl]);
			        				var item = self.$store.state.itemCollection[el.key[subSubEl].mod].find(function(subSubSubEl){return subSubSubEl.name == el.key[subSubEl].item;})
			        				icons[i*3+j] = item.image;
			        				titles[i*3+j] = item.displayName;
			        			};
			        		});
			        	});
			        	// console.log(meta);
			        	if (meta.recipe.pattern) {
				        	meta.recipe.pattern.forEach(function(subEl, i){
				        		subEl.split('').forEach(function(subSubEl, j){
				        			// console.log(meta.recipe.key[subSubEl]);
				        			if (subSubEl != ' ' && meta.recipe.key[subSubEl]) {
				        				// console.log(meta.recipe.key[subSubEl]);
				        				var item = self.$store.state.itemCollection[meta.recipe.key[subSubEl].mod].find(function(subSubSubEl){return subSubSubEl.name == meta.recipe.key[subSubEl].item;})
				        				iconsOld[i*3+j] = item.image;
				        				titlesOld[i*3+j] = item.displayName;
				        			};
				        		});
				        	});
			  			};	
		  				self.recipes.push({
		  					image: meta.image,
		  					displayName: meta.displayName,
		  					icons: icons,
		  					titles: titles,
		  					iconsOld: iconsOld,
		  					titlesOld: titlesOld,
		  					data: el,
		  					meta: meta,
		  				});
	  				};
	  			});
	  		});
  		},
  	},
};
</script>
